module.exports = __webpack_public_path__ + "img/sesuboard-sw.2e5ea438.jpg";